import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const arjTimelineEmbedRoute: InvariantJiraRoute = {
	name: 'software-advanced-roadmaps-embed',
	path: '/jira/plans/:planId/scenarios/:scenarioId/timeline/embed',
};
